module.exports = __webpack_public_path__ + "static/AdrienneBoris_CV_FULL-b0d8c0a86edff61436ad582fd5937d1a.pdf";